import React, { Component } from "react";
// import { movies } from './getMovies'
import axios from "axios";
import Pagination from "./Pagination";

export default class Movies extends Component {
  constructor() {
    super();
    this.state = {
      movies: [],
      currPage: 1,
      id:"",
      favourites:[],
      favMovies:[]
    };
  }

  // first api request mad here
  componentDidMount() {
    // side effect wle kaam jisme wait krna ho
    // console.log("side effet mounting");
    axios
      .get(
        `https://api.themoviedb.org/3/trending/all/week?api_key=6bac6e7f2d97716fb0a7d0d2a666c80f&page=${this.state.currPage}`
      )
      .then((res) => {
        let data = res.data;
        
        let movies = localStorage.getItem("favourites")
        movies = JSON.parse(movies)

        let fav = movies===null?[]:movies.map((movie)=>{
          return movie.id
        })
       
        // fav=fav.filter((obj)=>{
        //   return obj.id
        // })
        this.setState({
          movies: [...data.results],
          favourites: [...fav],
          favMovies:movies===null?[]:[...movies]
        });
      });
  }

  // api request after clicking on next or previous
  async changeMovies() {
    let cPage = this.state.currPage;
    // console.log(cPage);
    const res = await axios.get(
      `https://api.themoviedb.org/3/trending/all/week?api_key=6bac6e7f2d97716fb0a7d0d2a666c80f&page=${this.state.currPage}`
    );
    let data = res.data;
    // console.log(data.results);
    this.setState({
      movies: [...data.results],
      currPage:cPage
    });
  }

  // go to prev page and make api request
  onPrev = ()=>{
    if(this.state.currPage>1){
      this.setState({
        currPage:this.state.currPage-1
      },this.changeMovies)
      
    }
  }

  // go to next page and passes changeMovies as a paramter
  onNext = ()=>{
    // console.log("movie pagi");
    this.setState({
      currPage:this.state.currPage+1
    },this.changeMovies)
    
  }

  // show emoji when onMouseEnter
  showEmoji = (movieID)=>{
    this.setState({
      id:movieID
    })
  }

  // hide emoji onMouseLeave
  hideEmoji = ()=>{
    this.setState({
      id:""
    })
  }
  addToFavourites = async (movie)=>{
    await this.setState({
      favourites:[...this.state.favourites,movie.id],
      favMovies:[...this.state.favMovies,movie]
    })
   
    localStorage.setItem("favourites",JSON.stringify(this.state.favMovies))
    
  }
  removeFromFavourites = async (movie)=>{
   
    await this.setState({
      favourites:this.state.favourites.filter((movieId)=>{
        return movieId!==movie.id
      }),
      favMovies:this.state.favMovies.filter((favMovie)=>{
        // console.log(favMovie.id,movie.id);
        return movie.id!==favMovie.id
      })
    })
    
    localStorage.setItem("favourites",JSON.stringify(this.state.favMovies))
  }
  render() {
    // let movie = movies.results
    // console.log("render movie");
    return (
      <>
        {this.state.movies.length === 0 ? (
          <div className="flex justify-center m-12">
            <button
              disabled
              type="button"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center"
            >
              <svg
                aria-hidden="true"
                role="status"
                className="inline w-4 h-4 mr-3 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
              Loading...
            </button>
          </div>
        ) : (
          <div className="-mt-16">
            <div className="mb-4 text-2xl font-bold text-center">
              Trending Movies
            </div>
            <div className="flex flex-wrap justify-center">
              {this.state.movies.map((movieObj) => (
                // <div key={movieObj.id}>
                <div
                  key={movieObj.id} onMouseOver={()=>{this.showEmoji(movieObj.id)}} onMouseLeave={this.hideEmoji}
                  className="w-40 relative h-[30vh] m-4 rounded-xl hover:scale-110 duration-300 bg-contain bg-no-repeat bg-center flex items-end"
                  style={{
                    backgroundImage: `url("https://image.tmdb.org/t/p/original/${movieObj.poster_path}")`,
                    backgroundSize: "100% 100%",
                  }}
                >
                  <div style={{display:movieObj.id===this.state.id?"block":"none"}} className="absolute top-2 right-2 cursor-pointer p-2 bg-gray-900 rounded-2xl bg-opacity-90">
                    {
                      this.state.favourites.includes(movieObj.id)===true?
                      <div onClick={()=>this.removeFromFavourites(movieObj)} className="hover:scale-150 duration-300">❌</div>:
                      <div onClick={()=>this.addToFavourites(movieObj)} className="hover:scale-150 duration-300">😍</div>
                    }
                  
                  
                  </div>
                  {/* {console.log()} */}
                  <div className="text-white p-1 bg-gray-900 bg-opacity-60 text-center w-full rounded-b-xl">
                    {movieObj.original_title || movieObj.name}
                  </div>
                </div>
              ))}
            </div>
            {/* <Pagination currPage={this.state.currPage} onPrev={this.onPrev} onNext={this.onNext}/> */}
            <Pagination currPage={this.state.currPage} onPrev={this.onPrev} onNext={this.onNext}
            ></Pagination>
          </div>
        )}
      </>
    );
  }
}
